import { GET_HISTORICAL_OBS_BY_PROVIDER } from '../actions/historicalObsActions';

import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    historicalObsIsRefreshing: false
};

export function historicalObs(state = initialState, action) {
    switch (action.type) {
        case LOCATION_CHANGED:
        {
            return initialState;
        }

        case GET_HISTORICAL_OBS_BY_PROVIDER.pending:
        {
            return {
                ...state,
                historicalObs: undefined,
                historicalObsIsRefreshing: true
            };
        }

        case GET_HISTORICAL_OBS_BY_PROVIDER.fulfilled:
        {
            return {
                ...state,
                historicalObs: action.payload,
                lastError: undefined,
                historicalObsIsRefreshing: false
            };
        }

        case GET_HISTORICAL_OBS_BY_PROVIDER.rejected:
        {
            return {
                ...state,
                historicalObs: undefined,
                lastError: action.payload,
                historicalObsIsRefreshing: false
            };
        }
        default:
        {
            return state;
        }
    }
}
